import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import ReviewForm from './dynamic-form/ReviewForm';
import ReviewElement from './dynamic-report/ReviewElement';

class ReportReview extends Component {
  // ----------------------
  // Computed
  // ----------------------

  get showReviewed() {
    return this.props.report.approvedTwoAt;
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        {this.props.report.getCanApproveTwo(this.props.userContext.scope) &&
          <ReviewForm reportGuid={this.props.report.guid} />
        }
        {this.showReviewed &&
          <ReviewElement
            approvedTwoAt={this.props.report.approvedTwoAt}
            approvedTwoBy={this.props.report.getFullNameFor('approverTwo')}
            approveCommentTwo={this.props.report.approveCommentTwo}
          />
        }
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps, null)(ReportReview);
